export const GET_CURRENT_USER = `
query CurrentUser($input: GetCurrentUserInput) {
  getCurrentUser (input: $input) {
    currentUser {
      id
      name
      themeId
      appliedThemeId
      storeId
      planId
      storeWebsiteUrl
      storeDisplayName
      currencySymbol
      currencyUnit
      encryptedPlanId
      existingThemeId
      isFreeTheme
      isNewClient
      isDeprecatedThemeUser
      isTestAccount
      studioWriteAccess
      studioReadAccess
      firstName
      phone
      email
      address
      purchasedCurrencyDetails {
          currencyCode
          currencySymbol
        }
    }
    message
    statusCode
    success
    httpStatusCode
  }
}`
